import { takeLatest, call, put } from 'redux-saga/effects';

import { getAdvertisersList, addAdvertiser, editAdvertiser } from './api';
import {
  fetchAdvertisersListSuccess,
  fetchAdvertisersListFail,
  fetchAddOrEditAdvertiserSubmissionSuccess,
  fetchAddOrEditAdvertiserSubmissionFail,
} from './actions';
import advertisersActionTypes from './action-types';

function* fetchAdvertisersListSaga({ payload }) {
  try {
    const response = yield call(getAdvertisersList, payload);
    yield put(fetchAdvertisersListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchAdvertisersListFail(error));
  }
}

function* fetchAddOrEditAdvertiserSubmissionSaga({ payload }) {
  const { callbackActionSuccess } = payload;

  try {
    const { advertiserKey } = payload;

    if (advertiserKey) yield call(editAdvertiser, payload);
    else yield call(addAdvertiser, payload);

    callbackActionSuccess();
    yield put(fetchAddOrEditAdvertiserSubmissionSuccess());
  } catch (error) {
    yield put(fetchAddOrEditAdvertiserSubmissionFail(error));
  }
}

function* generalSaga() {
  yield takeLatest(advertisersActionTypes.FETCH_ADVERTISERS_LIST, fetchAdvertisersListSaga);
  yield takeLatest(
    advertisersActionTypes.FETCH_ADD_OR_EDIT_ADVERTISER_SUBMISSION,
    fetchAddOrEditAdvertiserSubmissionSaga,
  );
}

export default generalSaga;
